export enum MembershipType {
    Package = 'Package',
    Subscription = 'Subscription',
}

export const MembershipDisplay = [
    { active: '/images/ico-active-package.svg', selected: '/images/ico-selected-package.svg', translation: "common.package_desc" },
    { active: '/images/ico-active-subscription.svg', selected: '/images/ico-selected-subscription.svg', translation: "common.subscription_desc" }
]

export enum RedemptionUnit {
    CLASSES = 'Classes',
    AMOUNT = 'Amount',
    TIME = 'Time'
}

export const ValidityTypes = [
    { text: 'Days', value: 'DAYS' },
    { text: 'Weeks', value: 'WEEKS' },
    { text: 'Months', value: 'MONTHS' },
    { text: 'Years', value: 'YEARS' },
]

export const CycleTypes = [
    'Forever until cancelled',
    'Input fixed number of cycles',
]

export const RenewalActions = [
    { text: 'None', value: 'NONE' },
    { text: 'Reset', value: 'RESET' },
    { text: 'Roll Over', value: 'ROLLOVER' },
]

export const TimePeriods = [
    { text: 'Weekly', value: 'WEEKLY', short: 'week' },
    { text: 'Monthly', value: 'MONTHLY', short: 'month' },
    { text: 'Yearly', value: 'YEARLY', short: 'year' },
]

export const DEFAULT_LOCATION = {
    text: 'All Locations',
    value: 'all_locations'
}

export type MembershipApiItem = {
    additionalFee: number,
    categoryId?: string,
    categoryIds: string[],
    customSlug?: string,
    deletedAt: string,
    description?: string,
    groupId?: string,
    id?: string,
    imageUrl?: string,
    locationIds: string[],
    longDescription?: string,
    membershipPackage?: {
        id: string,
        validityType: string,
        validityValue: number
    },
    membershipSubscription?: {
        id: string,
        minimumRenewals: number,
        numberOfCycles: number,
        renewalAction: string,
        timePeriod: string,
        validRenewals: number
    },
    name: string,
    price: number
    primaryLocationId?: string
    public: boolean,
    redemptionAmount: number,
    redemptionMinutes: number,
    redemptionServices: number,
    serviceDiscountPercentage: number
    serviceIds: string[],
    tenantId: string,
    version: number
}

export interface MembershipBase {
    membership_type: string,
    category_id?: string,
    category_ids?: string[],
    location?: string,
    image_url?: string,
    name?: string,
    language?: string,
    description?: string,
    deleted_at?: string,
    group_id?: string,
    custom_slug?: string,
    long_description?: string,
    is_public?: boolean,
    price?: number,
    initial_fee?: number,
    additional_fee?: number,
    redemption_amount?: number,
    redemption_minutes?: number,
    redemption_services?: number,
    redemption_unit?: string,
    validity_value?: number,
    validity_type?: string,
    time_period?: string,
    service_discount_percentage: number,
    service_ids?: string[],
    slug?: string,
    payment?: string,
    cycles?: number,
    version?: number
}

export interface MembershipItem extends MembershipBase {
    id?: string,
    category_id?: string
    category?: {
        id: string,
        name?: string,
    },
    membership_package?: {
        id?: string,
        validity_type?: string,
        validity_value?: number
    },
    membership_subscription?: {
        id?: string,
        minimum_renewals?: number,
        number_of_cycles?: number,
        renewal_action?: string,
        time_period?: string,
        valid_renewals?: number
    },
    location_ids: string[]
    primary_location_id?: string
    primary_location?: Record<string, string>
}

export function denormalizeMembershipItem(m: MembershipApiItem): MembershipItem {
    const {
        id,
        name,
        description,
        deletedAt: deleted_at,
        categoryId: category_id,
        categoryIds: category_ids,
        locationIds: location_ids,
        additionalFee: initial_fee,
        price,
        public: is_public,
        redemptionAmount: redemption_amount,
        redemptionMinutes: redemption_minutes,
        redemptionServices: redemption_services,
        serviceDiscountPercentage: service_discount_percentage,
        serviceIds: service_ids,
        version,
        groupId: group_id,
        customSlug: custom_slug,
        imageUrl: image_url,
        primaryLocationId: primary_location_id
    } = m

    let membership_type
    let membership_package
    let membership_subscription = undefined
    if (m.membershipPackage) {
        membership_type = MembershipType.Package
        membership_package = {
            id: m.membershipPackage.id,
            validity_type: m.membershipPackage.validityType,
            validity_value:
                m.membershipPackage.validityValue,
        }
    } else {
        membership_type = MembershipType.Subscription
        membership_subscription = {
            id: m.membershipSubscription?.id,
            minimum_renewals:
                m.membershipSubscription?.minimumRenewals,
            number_of_cycles:
                m.membershipSubscription?.numberOfCycles,
            renewal_action:
                m.membershipSubscription?.renewalAction,
            time_period:
                m.membershipSubscription?.timePeriod,
            valid_renewals:
                m.membershipSubscription?.validRenewals,
        }
    }

    let redemption_unit = RedemptionUnit.CLASSES
    if (redemption_amount > 0) {
        redemption_unit = RedemptionUnit.AMOUNT
    }
    else if (redemption_minutes > 0) {
        redemption_unit = RedemptionUnit.TIME
    }

    return {
        id,
        group_id,
        custom_slug,
        image_url,
        name,
        description,
        deleted_at,
        category_id,
        category_ids,
        location_ids,
        membership_type,
        membership_package,
        membership_subscription,
        initial_fee,
        price,
        is_public,
        redemption_unit,
        redemption_amount,
        redemption_minutes,
        redemption_services,
        service_discount_percentage,
        service_ids,
        version,
        primary_location_id,
    }
}